import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

// firstName and lastName are also optional, to allow updating.
type PersonDetails = {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  dob?: string | null;
  gender?: string | null;
  nationality?: string | null;
  birthCountry?: string | null;
  ssn?: string | null;
  socialInsuranceNumber?: string | null;
  nationalIdentityNumber?: string | null;
  taxIdentificationNumber?: string | null;
};

type CompanyDetails = {
  name?: string | null;
  website?: string | null;
  registrationNumber?: string | null;
  incorporationCountry?: string | null;
  incorporationType?: string | null;
};

export type ClientRequest = {
  type?: string;
  email?: string | null;
  mobile?: string | null;
  telephone?: string | null;
  joinedDate?: string | null;
  personDetails?: PersonDetails | null;
  companyDetails?: CompanyDetails | null;
  metadata?: object | null;
  externalId?: string | null;
  lastActionBy?: string | null;
};

export type Client = {
  id: string;
  type?: string;
  email?: string | null;
  mobile?: string | null;
  telephone?: string | null;
  joinedDate?: string | null;
  personDetails?: PersonDetails | null;
  companyDetails?: CompanyDetails | null;
  metadata?: object | null;
  externalId?: string | null;
  lastActionBy?: string | null;
  createdAt: string;
  updatedAt: string;
};

export class Clients extends Resource<ClientRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("clients", axiosInstance);
  }

  public async create(clientRequest: ClientRequest): Promise<Client> {
    return this.request({ method: Method.POST, body: clientRequest });
  }

  public async get(id: string): Promise<Client> {
    return this.request({ method: Method.GET, path: id });
  }

  public async update(
    id: string,
    clientRequest: ClientRequest
  ): Promise<Client> {
    return this.request({ method: Method.POST, path: id, body: clientRequest });
  }

  public async delete(id: string): Promise<void> {
    await this.request({ method: Method.DELETE, path: id });
  }

  public async list({
    page,
    pageSize
  }: {
    page?: number;
    pageSize?: number;
  } = {}): Promise<Client[]> {
    const { items: clients } = await this.request({
      method: Method.GET,
      query: { page, pageSize }
    });

    return clients;
  }
}
